import React from 'react';
import './contact-form.css';

class ContactForm extends React.Component {
  state = {success: false, error: ''};

  componentDidMount() {
    $('#contact-form').submit(e => {
      e.preventDefault();
      const $form = $(e.target);

      $.post($form.attr('action'), $form.serialize())
        .then(() => {
          this.setState({success: true});
        })
        .catch(err => {
          this.setState({error: err.message});
        });
    });
  }

  render() {
    return (
      <>
        <h2>Get a quote</h2>
        {this.state.success ? (
          <p>
            Thank you! We&apos;ve recieved your message and will get back to you
            as soon as we can.
          </p>
        ) : (
          <form
            name="contact"
            method="POST"
            id="contact-form"
            className="rd-mailform rd-mailform_style-1 contact-form"
            data-form-type="contact"
          >
            {this.state.error && <p className="error">{this.state.error}</p>}
            <input type="hidden" name="form-name" value="contact" />
            <div
              style={{
                position: 'absolute',
                opacity: 0,
                height: 0,
                width: 0,
                visibility: 'hidden'
              }}
            >
              <input name="bot-field" />
            </div>
            <div className="form-wrap">
              <input
                className="form-input"
                id="contact-name"
                type="text"
                name="name"
                data-constraints="@Required"
              />
              <label
                className="form-label rd-input-label"
                htmlFor="contact-name"
              >
                Your name*
              </label>
            </div>
            <div className="form-wrap">
              <input
                className="form-input"
                id="contact-email"
                type="email"
                name="email"
                data-constraints="@Email @Required"
              />
              <label
                className="form-label rd-input-label"
                htmlFor="contact-email"
              >
                Your email*
              </label>
            </div>
            <div className="form-wrap">
              <input
                className="form-input"
                id="contact-phone"
                type="text"
                name="phone"
                data-constraints="@Required"
              />
              <label
                className="form-label rd-input-label"
                htmlFor="contact-phone"
              >
                Your phone*
              </label>
            </div>
            <div className="form-wrap contact-form__textarea">
              <textarea
                className="form-input"
                id="contact-message"
                name="message"
              />
              <label
                className="form-label rd-input-label"
                htmlFor="contact-message"
              >
                Your journey details…
                <br />
                Please let us know date, time and address of pick up and drop
                off as well as further requests (cycle transfer etc).
              </label>
            </div>
            <button className="button btn-secondary" type="submit">
              send
            </button>
          </form>
        )}
      </>
    );
  }
}

export default ContactForm;
